var map = {
	"./assets/clickable/flickr.svg": "fb502695e8489e04ac8d",
	"./assets/disabled/flickr.svg": "827555eff3ced023c328",
	"./assets/original/flickr.svg": "d256da904ab6ce2b1007"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "289ac3a761bec00c5b3c";